<template>
  <button
    :type="buttonType"
    :class="` ${bgColors} ${classes}  ${textColor} line-clamp-1 flex transform select-none items-center justify-center gap-2 whitespace-nowrap rounded px-4 py-3 text-min text-white shadow-sm hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-disabled disabled:text-tertiary disabled:shadow-sm ${
      iconPosition === 'left' ? 'flex-row-reverse' : 'flex-row'
    }`"
    :disabled="isDisabled"
    @click="$emit('click')"
    @submit="$emit('submit')"
  >
    <slot />
    <slot name="icon" />
  </button>
</template>

<script>
export default {
  name: 'ButtonWithIcon',

  props: {
    buttonType: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconPosition: {
      type: String,
      default: 'right',
    },
    bgColors: {
      type: String,
      default: 'bg-main-primary hover:bg-main-secondary active:bg-main-primary',
    },
    classes: {
      type: String,
      default: '',
    },

    textColor: {
      type: String,
      default: 'text-white',
    },
  },

  emits: ['click', 'submit'],

  data() {
    return {
      isDisabled: this.disabled,
    }
  },

  watch: {
    disabled(newValue) {
      this.isDisabled = newValue
    },
  },
}
</script>
